import React, { useEffect } from 'react';
import {
  BrowserRouter as Router, Switch, Route,
} from "react-router-dom";

import { useSelector, useDispatch } from 'react-redux';
import NoInternetConnection from './components/NoInternetConnection';
import { updateConnectionStatus } from './stores/general/internet/internet.action';
import HomeScreen from './screens/HomeScreen';
import ResultScreen from './screens/ResultScreen';
import VerifySuccess from './screens/MobileAuthentication/Screens/VerifySuccess';
import VerifyError from './screens/MobileAuthentication/Screens/VerifyError';
import { injectDebugger } from './utils/utils';
import BindingResult from './screens/BindingResult/BindingResult';

const routes = [
  { path: `/result`, component: ResultScreen },
  { path: `/verify-success`, component: VerifySuccess },
  { path: `/verify-error`, component: VerifyError },
  { path: `/binding/authentication`, component: HomeScreen },
  { path: `/binding/result`, component: BindingResult },
  { path: `/`, component: HomeScreen },
  { path: `/wallet-association/binding/authentication`, component: HomeScreen },
]

export default function App() {
  const { isConnected } = useSelector(state => state.internet);
  const dispatch = useDispatch();

  const initialize = async () => {
    if (window.runtime_configs.REACT_APP_IS_PROD !== '1') {			
      await injectDebugger();
		}
	};

  useEffect(() => {
    dispatch(updateConnectionStatus(window.navigator.onLine));
    window.addEventListener('offline', function() {dispatch(updateConnectionStatus(false))});
    window.addEventListener('online', function() {dispatch(updateConnectionStatus(true))});

    initialize();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div>
      {!isConnected ? <NoInternetConnection/> : null}
      <Router>
        <Switch>
          {routes.map(((route, index) => {
            return (
              <Route key={index} path={route.path}>
                <route.component />
              </Route>
            )
          }))}
        </Switch>
      </Router>
    </div>

  );
}
